import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/weeble.module.css';

export const Weeble = ({ className, variant = 'one', ...props }: { className?: string; variant?: 'one' | 'two' | 'three'; }) => (
  <div className={generateClassName([className, styles.weeble, styles[variant]])} {...props} />
);
